(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"), require("babylonjs-gui"));
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-accessibility", ["babylonjs", "babylonjs-gui"], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-accessibility"] = factory(require("babylonjs"), require("babylonjs-gui"));
	else
		root["ACCESSIBILITY"] = factory(root["BABYLON"], root["BABYLON"]["GUI"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__597__, __WEBPACK_EXTERNAL_MODULE__490__) => {
return 